import React from 'react';
import { connect } from 'react-redux';

import Animate from '@components/animate/Animate.tsx';
import Link from '@components/link/Link.tsx';
import Loader from '@components/loader/Loader.tsx';
import { StoreT } from '@global/types.ts';

import LegalNavI from './types.ts';

class LegalNav
    extends React.Component<LegalNavI['props'], LegalNavI['state']>
    implements LegalNavI
{
    parent: LegalNavI['parent'];

    constructor(props: LegalNavI['props']) {
        super(props);
        this.state = {};

        this.parent = React.createRef();
    }

    render() {
        const { isSmallMenu, levels, callback, shortList } = this.props;

        return (
            <div
                className={`publicLegalNav ${shortList ? '_ready' : ''} ${
                    isSmallMenu ? '_small' : ''
                }`}
            >
                <div className="publicLegalNav__title">
                    Содержание:
                    <Animate className="publicLegalNav__loader" isShow={!shortList}>
                        <Loader className="_main" />
                    </Animate>
                </div>
                <Animate className="publicLegalNav__content" isShow={!!shortList}>
                    {shortList?.map((page, index) => {
                        const { title, url } = page;
                        const isCurrent = url === levels[2] || (index === 0 && !levels[2]);

                        return (
                            <div
                                className={`publicLegalNav__item ${isCurrent ? '_current' : ''}`}
                                key={page._id}
                            >
                                <Link
                                    className="publicLegalNav__link"
                                    pageName="public-legal-inner"
                                    ids={{ 2: url }}
                                    callback={() => {
                                        if (typeof callback === 'function') {
                                            callback();
                                        }
                                    }}
                                >
                                    {title}
                                </Link>
                            </div>
                        );
                    })}
                </Animate>
            </div>
        );
    }
}

function mapStateToProps(state: StoreT) {
    return {
        levels: state.levels,
    };
}

export default connect(mapStateToProps)(LegalNav);
